import { render, staticRenderFns } from "./SubjectTip.vue?vue&type=template&id=34dc2b6a&scoped=true&lang=pug&"
import script from "./SubjectTip.vue?vue&type=script&lang=ts&"
export * from "./SubjectTip.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectTip.vue?vue&type=style&index=0&id=34dc2b6a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc2b6a",
  null
  
)

export default component.exports